import codeEditorService from '@/services/embeds/plugin/code.editor.service'
import exeMatrixService from '@/services/embeds/plugin/exe.matrix.service'
import outputEditorService from '@/services/embeds/plugin/output.editor.service'
import versionSelectService from '@/services/embeds/plugin/version.select.service'

import {
  useEmbedConfigureStore,
  type IComponentSettings
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'

/**
 * On select language change
 */
const onSelectLanguageChange = () => {
  const languages = useEmbedConfigureStore().getEmbedConfig?.languages || []
  const language = useIdeStore().selectedLanguage || languages[0]

  // set the versions
  versionSelectService.initVersionList()
  exeMatrixService.resetExeMatrix()

  codeEditorService.codeEditorSetLanguage(language?.language)
  if (language?.program) codeEditorService.codeEditorSetProgram(JSON.parse(language?.program))
  else codeEditorService.codeEditorSetProgram('')
  codeEditorService.codeEditorSetTheme(language?.theme || 'xcode')
  codeEditorService.heightChangeFunction()
  // output
  outputEditorService.outputEditorSetProgram('')
  outputEditorService.heightChangeFunction()
}
/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.LANGUAGELIST
  )?.configStyle
  const hideTitle = settongs?.find((setting) => setting.id === 'hideTitle')?.value || 'true'
  useIdeStore().setLanguageListHideTitle(hideTitle === 'true' || false)
  const titleName =
    settongs?.find((setting) => setting.id === 'titleName')?.value || 'Select Language:'
  useIdeStore().setLanguageListTitleName(titleName)
  const display = settongs?.find((setting) => setting.id === 'display')?.value || 'true'
  useIdeStore().setLanguageListDisplay(display === 'true' || false)
}
/**
 * Init language list
 */
const initLanguageList = () => {
  const languages = useEmbedConfigureStore().getEmbedConfig?.languages || []
  if (languages.length) {
    useIdeStore().setSelectedLanguage(languages[0])
    onSelectLanguageChange()
  } else useIdeStore().setSelectedLanguage(null)
}
/**
 * Destroy language list
 */
const destroyLanguageList = () => {
  const languages = useEmbedConfigureStore().getEmbedConfig?.languages || []
  if (languages.length) {
    useIdeStore().setSelectedLanguage(languages[0])
    onSelectLanguageChange()
  } else useIdeStore().setSelectedLanguage(null)
}

export default {
  destroyLanguageList,
  initLanguageList,
  onSettingChange,
  onSelectLanguageChange
}
